import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import PreviewPagesSpread from '../../../components/Editor/PreviewPagesSpread';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesController: { spreads, currentSpreadIndex },
			spreadZoom,
		},
	} = state;

	return {
		spread: spreads[currentSpreadIndex],
		zoom: spreadZoom,
	};
};

export default connect(mapStateToProps)(PreviewPagesSpread);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/PreviewPagesSpread/index.tsx